import { render, staticRenderFns } from "./ieltsmentor_collapse_hinh_thuc_thanh_toan.vue?vue&type=template&id=fa1791a4&scoped=true"
import script from "./ieltsmentor_collapse_hinh_thuc_thanh_toan.vue?vue&type=script&lang=js"
export * from "./ieltsmentor_collapse_hinh_thuc_thanh_toan.vue?vue&type=script&lang=js"
import style0 from "./ieltsmentor_collapse_hinh_thuc_thanh_toan.vue?vue&type=style&index=0&id=fa1791a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa1791a4",
  null
  
)

export default component.exports